<template>
    <div class="route-stack">
        <keep-alive>
            <router-view v-if="showTabRootView" />
        </keep-alive>
        <keep-alive include="AddMeetingRoom,selectMeetingRoomTimeSlot">
            <router-view v-if="showSecondaryView" />
        </keep-alive>
    </div>
</template>

<script>
export default {
    name: 'RouteStack',
    data() {
        return {
            /** 本栈实例所属 Tab（首次挂载时写入，避免随全局 $route 串栈） */
            stackKey: '',
        }
    },
    created() {
        this.captureStackKey()
    },
    computed: {
        isActiveStack() {
            if (!this.stackKey) return false
            const active = this.$route.matched[1]
            return !!(active && active.meta.stackKey === this.stackKey)
        },
        isTabRootRoute() {
            const matched = this.$route.matched
            if (!matched.length) return false
            return matched[matched.length - 1].meta.tabRoot === true
        },
        /** 仅当前 Tab 栈随路由切换；其它被 keep-alive 的栈保持 Tab 根出口，避免误销毁 homeView 等 */
        showTabRootView() {
            if (!this.isActiveStack) {
                return true
            }
            return this.isTabRootRoute
        },
        showSecondaryView() {
            if (!this.isActiveStack) {
                return false
            }
            return !this.isTabRootRoute
        },
    },
    methods: {
        captureStackKey() {
            const record = this.$route.matched[1]
            if (record && record.meta.stackKey) {
                this.stackKey = record.meta.stackKey
            }
        },
    },
}
</script>

<style scoped>
.route-stack {
    min-height: inherit;
}
</style>
